import React from 'react';
import './ui.css';

interface LockedValueProps {
  text?: string;
  className?: string;
}

const LockedValue: React.FC<LockedValueProps> = ({ text = 'Unlock', className = '' }) => {
  return <span className={`ui-locked-value ${className}`.trim()}>{text}</span>;
};

export default LockedValue;
